import { Divider, Stack, Typography } from "@mui/material"
import { ReactElement } from "react";

interface Props {
    title: string;
    action?: ReactElement;
}

const PageHeader = ({ title, action }: Props) => {
    return (
        <Stack>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                    paddingY: 2
                }}
            >
                <Typography variant="h2">
                    {title}
                </Typography>
                {action ? action : null}
            </Stack>
            <Divider/>
        </Stack>
    )
}

export default PageHeader;
